module.exports = __webpack_public_path__ + "img/006-shark.c43456fc.svg";